import axios from "axios";
const service = axios.create({
    headers:{
        'Content-Type': 'application/json;charset=UTF-8',
    },
});
service.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
export default service;
